import React from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar, FiArrowRight } from 'react-icons/fi';
import SEO from '../../components/SEO';

const blogPosts = [
    {
        id: 'best-clothing-styles-2026',
        title: 'Best clothing styles in Sri Lanka 2026',
        excerpt: 'Discover the hottest fashion trends set to dominate the Sri Lankan streets in 2026...',
        date: 'April 27, 2024',
        image: '/images/hip_hop_swag.png'
    },
    {
        id: 'affordable-fashion-trends',
        title: 'Affordable fashion trends Sri Lanka',
        excerpt: 'How to look your best without breaking the bank. Our guide to budget-friendly style...',
        date: 'April 25, 2024',
        image: '/images/blog_affordable_fashion.png'
    }
];

const BlogListPage = () => {
    return (
        <div className="bg-slate-50 min-h-screen pb-24">
            <SEO
                title="Blog"
                description="Fashion inspiration, style tips and Sri Lankan clothing trends from the Cider Clothings blog."
                url="/blog"
            />
            {/* Hero Section */}
            <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-gray-900 py-24 px-4 text-center relative overflow-hidden">
                <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
                <div className="relative z-10">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight">
                        Cider Blog
                    </h1>
                    <p className="text-slate-300 text-lg md:text-xl max-w-2xl mx-auto font-medium">
                        Your daily dose of fashion inspiration and trends in Sri Lanka.
                    </p>
                </div>
            </div>

            {/* List Section */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {blogPosts.map((post) => (
                        <div key={post.id} className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow">
                            <img src={post.image} alt={post.title} className="w-full h-64 object-cover" />
                            <div className="p-8">
                                <div className="flex items-center text-slate-500 text-sm mb-4">
                                    <FiCalendar className="mr-2" />
                                    {post.date}
                                </div>
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">{post.title}</h2>
                                <p className="text-gray-600 mb-6 leading-relaxed">
                                    {post.excerpt}
                                </p>
                                <Link
                                    to={`/blog/${post.id}`}
                                    className="inline-flex items-center text-slate-900 font-bold hover:text-slate-700 transition-colors"
                                >
                                    Read More <FiArrowRight className="ml-2" />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlogListPage;
